import { createApp } from 'vue';
import DocumentArchiveBlock from './DocumentArchiveBlock.vue';
import "./DocumentArchiveBlock.scss";
import "./DocumentLinkBlock.scss";

const mountingDocumentArchiveBlocks = document.querySelectorAll('[data-feature="document-archive-block"]');
mountingDocumentArchiveBlocks.forEach(mountingDocumentArchiveBlock => {
	if (mountingDocumentArchiveBlock) {
		const app = createApp({
			name: 'DocumentArchiveBlockApp',
		});
		app.component('document-archive-block', DocumentArchiveBlock);
		app.mount(mountingDocumentArchiveBlock);
	}
});
